<template>
  <div id="mythVsFactOne"></div>
</template>

<script>
export default {
  name: "MythVsFactOne",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        myth: "You need to post every day to grow on LinkedIn",
        fact: "Consistency matters more than frequency. 3 quality posts per week beats 7 rushed ones.",
        chip: "Myth Busted",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler() {
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    isDarkColor(color) {
      let r, g, b;
      if (color.startsWith("#")) {
        const hex = color.slice(1);
        if (hex.length === 3) {
          r = parseInt(hex[0] + hex[0], 16);
          g = parseInt(hex[1] + hex[1], 16);
          b = parseInt(hex[2] + hex[2], 16);
        } else {
          r = parseInt(hex.substring(0, 2), 16);
          g = parseInt(hex.substring(2, 4), 16);
          b = parseInt(hex.substring(4, 6), 16);
        }
      } else {
        const rgb = color.match(/\d+/g);
        if (!rgb || rgb.length < 3) return false;
        r = parseInt(rgb[0]);
        g = parseInt(rgb[1]);
        b = parseInt(rgb[2]);
      }
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness < 128;
    },
    render() {
      const el = document.getElementById("mythVsFactOne");
      if (!el) return;
      el.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const labelSize = exporting ? 24 : 24 * this.scale;
      const textSize = exporting ? 36 : 36 * this.scale;
      const logoHeight = exporting ? 50 : 50 * this.scale;
      const chipSize = exporting ? 24 : 24 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.dark || "";
      const primaryColor =
        this.workspace?.branding?.color?.primary || "#22c55e";

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background-color: #f5f5f5;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
          "
        >
          <div style="padding: 10%">
            <img src="${logoSrc}" height="${logoHeight}px" alt="" />
          </div>

          <div style="padding: 0 10%;">
            <!-- Myth -->
            <div style="margin-bottom: 40px;">
              <div style="
                font-size: ${labelSize}px;
                font-weight: 700;
                color: #ef4444;
                text-transform: uppercase;
                letter-spacing: 0.1em;
                margin-bottom: 12px;
                display: flex;
                align-items: center;
                gap: 8px;
              ">
                <span style="font-size: ${labelSize * 1.2}px;">❌</span> MYTH
              </div>
              <div style="
                font-size: ${textSize}px;
                font-weight: 400;
                color: #737373;
                line-height: 1.4;
                text-decoration: line-through;
                text-decoration-color: #ef4444;
                border-left: 4px solid #ef4444;
                padding-left: 20px;
              ">${this.data.myth}</div>
            </div>

            <!-- Fact -->
            <div>
              <div style="
                font-size: ${labelSize}px;
                font-weight: 700;
                color: ${primaryColor};
                text-transform: uppercase;
                letter-spacing: 0.1em;
                margin-bottom: 12px;
                display: flex;
                align-items: center;
                gap: 8px;
              ">
                <span style="font-size: ${labelSize * 1.2}px;">✅</span> FACT
              </div>
              <div style="
                font-size: ${textSize}px;
                font-weight: 500;
                color: #272727;
                line-height: 1.4;
                border-left: 4px solid ${primaryColor};
                padding-left: 20px;
              ">${this.data.fact}</div>
            </div>
          </div>

          <div style="padding: 10%">
            <div style="display: flex;">
              <span
                style="
                  display: inline-block;
                  background: ${primaryColor};
                  color: ${this.isDarkColor(primaryColor) ? "#fff" : "#000"};
                  font-size: ${chipSize}px;
                  font-weight: 500;
                  border-radius: 999px;
                  padding: 7px 22px;
                  letter-spacing: 0.03em;
                  font-family: 'Inter', Arial, sans-serif;
                "
              >
                ${this.data.chip}
              </span>
            </div>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>

<style scoped></style>
